import { useState, useEffect, useDispatch, useSelector } from './basic'
import { resetError } from 'store/actions'

const useError = (field, onChange) => {
  const error = useSelector(s => s.responseMessages[field])
  const [value, setValue] = useState('')
  const [modified, setModified] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    error && setModified(false)
    return () => error && dispatch(resetError(field))
  }, [error])

  const _onChange = e => {
    onChange?.(e)

    if (value != e.target.value) {
      setValue(e.target.value)
      setModified(true)
    }
  }
  return [modified ? '' : error?.message, _onChange]
}

export { useError as default, useError }
